import { useContext } from "react";
import { MainContext } from "./Context/MainContext";
import { Routes, Route, Navigate } from "react-router-dom";

import Landing from "./components/Landing/Landing";
import Portal from "./components/Portal/Portal";
import Loading from "./components/Portal/Loading/Loading";
import Login from "./components/Portal/Login/Login";
import Dashboard from "./components/Portal/Dashboard/Dashboard";
import Privacy from "./components/Landing/Privacy/Privacy";

function MainRoutes() {
  const { user, justLoaded } = useContext(MainContext);

  return (
    <Routes>
      <Route index element={<Landing />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="portal" element={<Portal />}>
        {justLoaded ? (
          <Route index element={<Loading />} />
        ) : (
          <>
            {user ? (
              <Route index element={<Navigate to="/dashboard" />} />
            ) : (
              <Route index element={<Login />} />
            )}
          </>
        )}
      </Route>
      {user ? <Route path="dashboard/*" element={<Dashboard />}></Route> : null}
      <Route path="*" element={<Navigate to="portal" replace={true} />} />
    </Routes>
  );
}

export default MainRoutes;

// <Route index element={user
//                             ? <Navigate to='dashboard' />
//                             : <Login />} />
//                         <Route path='dashboard/*' element={!user
//                             ? <Navigate to='/portal' />
//                             : <Dashboard />} />
